<template>
  <section class="content">
    <div>
      <div id="overlay" v-if="loading">
        <div class="spinner"></div>
        <br/>
        <h4>Loading...</h4>
      </div>
      <div class="box box-info">
        <form>
          <div class="p-fluid p-formgrid p-grid">
            <!-- <div class="p-field p-col-12 p-md-2">
             <label for="fromDate">From Date</label>
             <date-picker v-model="fromDate" valueType="format"  v-if="!englishDateEnabled"/>
             <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label for="toDate">To Date</label>
              <date-picker v-model="toDate" valueType="format"  v-if="!englishDateEnabled"/>
              <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
            </div> -->
            <!-- <div class="p-field p-col-12 p-md-2">
              <label for="toDate">Store</label>
              <Dropdown
               v-if="!setWarehouseData"
                v-model="warehouseId"
                :options="warehouseLists"
                optionLabel="name"
                id="warehouse"
                :filter="true"
                placeholder="Select store"
                :showClear="true"
              />
              <Dropdown
               v-if="setWarehouseData"
                v-model="warehouseId"
                :options="warehouseLists"
                optionLabel="name"
                id="warehouse"
                :filter="true"
                placeholder="Select store"
                :disabled="true"
              />
          </div> -->

            <div class="p-field p-col-12 p-md-1 p-mt-5">
              <Button @click.prevent="searchReport"
                      class="p-button-raised" label="Search" icon="pi pi-search"/>
            </div>
          </div>
        </form>
        <!-- <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-col-12">
            <a href="#" @click.prevent="exportCSV()" v-if="this.analysisPurchaseQuaterlyItemWiseLists.length > 0">
              <img src="../../../../static/img/excel.png" style="margin-left: 90em;height: 3em;width: 3em;"/>
            </a> -->
            <DataTable :value="analysisPurchaseQuaterlyItemWiseLists"
                       ref="po"
                       :rowsPerPageOptions="[100,500,1000]" :paginator="true" :rows="100" 
                       :filters="filters"
                       exportFilename="purchaseAanalysisQuarterlyCustomerWise"
                       class="p-datatable-responsive p-datatable-gridlines"
                       data-key="id">
                       <template #header>
            <div style="text-align: left">
              <Button icon="pi pi-external-link" label="Export" @click="exportCSV($event)" />
            </div>
          </template>
              <!-- <Column header="S.N" field="id"/> -->
              <Column header="Group" :sortable="true" field="groupName" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['groupName']"/>
                </template>
              </Column>
              <Column header="Item Name" :sortable="true" field="itemName" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['itemName']"/>
                </template>
              </Column>
              <Column header="Item Code" :sortable="true" field="itemCode" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['itemCode']"/>
                </template>
              </Column>
              <Column header="Unit" :sortable="true" field="unit" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['unit']"/>
                </template>
              </Column>
              <Column header="Quarter1" :sortable="true" field="q1" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['q1']"/>
                </template>
              </Column>
              <Column header="Quarter2" :sortable="true" field="q2" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['q2']"/>
                </template>
              </Column>
              <Column header="Quarter3" :sortable="true" field="q3" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['q3']"/>
                </template>
              </Column>
              <Column header="Quarter4" field="q4" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['q4']"/>
                </template>
              </Column>
              <Column header="Total" field="total" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['total']"/>
                </template>
              </Column>
              <template #empty>No record found</template>
            </DataTable>
          <!-- </div>
        </div> -->
      </div>
    </div>
  </section>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
// import globalKey from '../../../store/globalKey'
// import axios from 'axios'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'

export default {
  name: 'analysisPurchaseQuaterlyItemWiseLists',
  data() {
    return {
      fromDate: null,
      toDate: null,
      warehouse: '',
      warehouseId: '',
      formatted_date: '',
      analysisPurchaseQuaterlyItemWiseLists: [],
      loading: false,
      columnList: '',
      id: '0',
      filters: {},
      englishDateEnabled: true,
      setWarehouseData: false
    }
  },
  mounted() {
    this.warehouseList()
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
    this.setWarehouse()
  },
  computed: {
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    }
  },
  methods: {
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    async searchReport() {
      if (this.warehouseId !== '' && this.warehouseId !== null) {
        this.id = this.warehouseId.id
      } else {
        this.id = '0'
      }
      let dat = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        warehouse: this.id
      }
      this.loading = true
      let resp = await this.$store.dispatch('loadPurchaseAnalysisQuaterlyItemWiseReport', dat)
      this.loading = false
      this.analysisPurchaseQuaterlyItemWiseLists = resp
    },
    setWarehouse() {
      if (this.$store.state.warehouseData.id > 0) {
        this.setWarehouseData = true
        this.warehouseId = this.$store.state.warehouseData
      } else if (this.warehouseLists.length === 1) {
        this.warehouseId = this.warehouseLists[0]
      }
    },
    exportCSV() {
      this.$refs.po.exportCSV()
    },
    // exportCSV() {
    //   let data = {
    //     fromDate: this.fromDate,
    //     toDate: this.toDate,
    //     columnList: this.columnList,
    //     itemId: 0
    //   }
    //   axios({
    //     url: globalKey + '/fileDownload/excelReportInventory/' + data.itemId + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/Inventory In-Out Report' + '/' + this.$store.getters.fyId + '/' + data.columnList,
    //     method: 'get',
    //     headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
    //     responseType: 'blob'
    //   }).then((response) => {
    //     const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
    //     const link = document.createElement('a')
    //     const contentDisposition = response.headers['content-disposition']
    //     let fileName = 'inventoryInOutReport.xlsx'
    //     if (contentDisposition) {
    //       const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
    //       if (fileNameMatch.length === 2) {
    //         fileName = fileNameMatch[1]
    //       }
    //     }
    //     link.href = url
    //     link.setAttribute('download', fileName)
    //     document.body.appendChild(link)
    //     link.click()
    //     link.remove()
    //     window.URL.revokeObjectURL(url)
    //   })
    // },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    reset() {
      this.analysisPurchaseQuaterlyItemWiseLists = []
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    InputText,
    InputMask,
    // Dropdown,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// purchaseAnalysisQuarterlyProductWise.vue?8da224a4